<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            SCM / Inventory Management
          </div>

          <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- <el-tab-pane label="Vendor Invoices" name="vendorInvoices">
              <vendor-invoices ref="vendorInvoices"/>
            </el-tab-pane> -->
            <el-tab-pane label="Inventory Locations" name="inventoryLocations">Inventory Locations</el-tab-pane>
            <el-tab-pane label="Inventory Transfers" name="inventoryTransfers">Inventory Transfers</el-tab-pane>
            <el-tab-pane label="Stock Counts" name="stockCounts">Stock Counts</el-tab-pane>
            <el-tab-pane label="Quantity Adjustments" name="quantityAdjustments">Quantity Adjustments</el-tab-pane>
            <el-tab-pane label="Warehouse Items Report" name="warehouseItemsReport">
              <warehouse-items-report ref="warehouseItemsReport"/>
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VendorInvoices from '@/components/sourceDocuments/VendorInvoices'
  import WarehouseItemsReport from '@/components/warehousing/WarehouseItemsReport'

  export default {
    name: 'Warehousing',
    components: {
      VendorInvoices,
      WarehouseItemsReport,
    },
    data() {
      return {
        activeName: 'warehouseItemsReport',
      }
    },
    mounted() {
      this.$refs['warehouseItemsReport'].openTab()
    },
    methods: {
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      handleClick(tab, event) {
        this.$refs[tab.name].openTab()
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
